
import Vue, { PropType } from 'vue'

export interface Card {
    label: string
    value: string | number
    note: string
    color?: 'indigo' | 'teal' | 'red' | 'amber' | 'wasabi'
}

/** Карточки показателей из макета (metrics()). */
export default Vue.extend({
    name: 'Opz2Cards',
    props: { items: { type: Array as PropType<Card[]>, required: true } },
})
